import {
  ChangeDetectionStrategy,
  Component,
  InjectionToken,
  Input,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
export const STUDIO_LIST = new InjectionToken<ListComponent>('ListComponent');

@Component({
  selector: 'studio-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: STUDIO_LIST, useExisting: ListComponent }],
})
export class ListComponent implements OnChanges, OnDestroy {
  @Input() public disabled = false;
  public stateChanges = new Subject<void>();

  constructor() {}

  ngOnChanges() {
    this.stateChanges.next();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }
}
